/*
 * Project: forca
 * File Created: Thursday, 28th April 2022 2:48:51 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { useState, useEffect } from 'react';

import NemID from './nemid.component';

import { setPenstionsinfoLoggedin } from '@Store/auth.store';

import { NemIDContainerProps } from './nemid.definition';

export const NemIDContainer = (props: NemIDContainerProps) => {
	const {
		currentBlock,
		linkTilPensionsInfo,
		identitetsNoegle,
		pensionskasseNr,
		navn
	} = props;

	//const [ticket, setTicket] = useState('');
	const [ssoUrl, setSSOUrl] = useState('');
	const [visFejl] = useState(false);

	useEffect(() => {
		//hentTicket();
		getUrlSsoTilPensionsInfoMitid();
	}, []);

	// CLBE tilføjet start
	const getUrlSsoTilPensionsInfoMitid = async () => {
		//	App.Util.globalLoader.start();
		//debugger;

		const urlHentSSO = '/login/MitIdApi/HentPIUrl';
		const jsonDataPIURL = {
			Medlemsnavn: navn,
			IdNoegle: identitetsNoegle,
			PensionskasseNr: pensionskasseNr,
			KnapTekst: currentBlock.sendTilRaadgivningKnapTekst
		};

		const jsonDataUrl = {
			method: 'POST',
			headers: {
				'content-type': 'application/json; charset=utf-8'
			},
			body: JSON.stringify(jsonDataPIURL)
		};

		await fetch(urlHentSSO, jsonDataUrl)
			.then(res => res.json())
			.then((result) => {
				setSSOUrl(result.value);
			},
			(error) => {
				console.error('Error: ', error);
			}
			);
	};
	// CLBE tilføjet slut

	/*
	const hentTicket = async () => {
		const response = await fetch('/api/PensionsInfoApi/HentTicket', {
			method: 'POST',
			cache: 'no-cache',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				SendTilRaadgivningKnapTekst: currentBlock.sendTilRaadgivningKnapTekst, SendTilRaadgivningEmail: currentBlock.sendTilRaadgivningEmail, SendTilRaadgivning: true
			})
		});

		const jsonData = await response.json();

		if (jsonData.Ticket != null) {
			setTicket(jsonData.Ticket);
		} else {
			setVisFejl(true);
		}
	};
	*/
	const receiveMessage = (event: any) => {
		if (event.origin !== linkTilPensionsInfo.originalString.replace(linkTilPensionsInfo.localPath, '')) {
			return;
		}

		const frameData = event.data || {};

		if (frameData.action === 'ClosePopUp') {
			// TODO: MOVE THIS TO THE LOCATION WHERE WE ARE SURE THAT THE USER IS LOGGEDIN ON PENTIONINFO
			setPenstionsinfoLoggedin(true);

			return (
				<div>Data overført</div>
			);
		}
	};

	const submitForm = (event: any) => {
		//	const url = encodeURI(linkTilPensionsInfo.originalString) + '?ticket=' + ticket;
		const url = ssoUrl;
		window.open(url, event.target.toString(), 'width=1000,height=750');
		window.addEventListener('message', receiveMessage, false);
	};

	const containerFunctions = {
		submitForm: submitForm.bind(this)
	};

	const containerProps = () => {
		return {
			...props,
			ssoUrlGenerated: (ssoUrl && ssoUrl.length > 0),
			visFejl
		};
	};

	return (
		<NemID
			{ ...containerProps() }
			{ ...containerFunctions }
		/>
	);
};

export default NemIDContainer;